<template>
  <v-row>
    <v-col cols="3">
      <v-card class="mt-7">
        <v-card-title class="grey lighten-2">
          <div class="account-avatar">
            <v-tooltip right>
              <template v-slot:activator="{on}">
                <v-btn v-on="on" icon height="66" width="66" class="primary" elevation="4">
                  <v-avatar size="64">
                    <img
                      v-if="$store.state.USER.avatar"
                      :src="$store.state.USER.avatar"
                      :alt="$store.state.USER.username"
                    />
                    <v-icon v-else size="64" color="primary">account_circle</v-icon>
                  </v-avatar>
                </v-btn>
              </template>
              <span>点击更换头像</span>
            </v-tooltip>
          </div>
          <h4 class="mt-6 text-center" style="width:100%;font-weight: 300;">
            {{$store.state.USER.username}}
            <v-chip
              class="ml-2"
              :color="$store.state.USER.level >= 0 ? 'primary' : 'info'"
              label
              small
            >{{$store.state.USER.level >= 0 ? `Lv${$store.state.USER.level}` : `Dev${Math.abs($store.state.USER.level)}`}}</v-chip>
          </h4>
        </v-card-title>
        <v-divider></v-divider>
        <v-progress-linear value="2"></v-progress-linear>
        <v-card-text>
          <div class="account-infobox">
            <h5>UID:</h5>
            <span class="ml-2">{{$store.state.USER.uid}}</span>
          </div>
          <div class="account-infobox">
            <h5>Pixel:</h5>
            <span class="ml-2">
              {{$store.state.USER.pixel}}
              <small>个</small>
            </span>
          </div>
          <div class="account-infobox">
            <h5>Emerald:</h5>
            <span class="ml-2">
              {{$store.state.USER.emerald}}
              <small>颗</small>
            </span>
          </div>
        </v-card-text>
      </v-card>
    </v-col>
    <v-col cols="9">
      <h3>资料</h3>
      <v-alert v-if="!$store.state.USER.emailVerified" type="error">您必须完成邮箱验证后才能修改资料。</v-alert>
      <v-card :disabled="!$store.state.USER.emailVerified">
        <v-card-title class="primary darken-1 white--text py-1 mb-0">
          <h5 id="username">用户名</h5>
        </v-card-title>
        <v-form ref="updates" style="color:rgba(0, 0, 0, 0.6);">
          <v-card-text>
            <span>用户名是唯一的，并且会伴随您在MAKjust产品与Minecraft中。</span>
            <v-text-field
              dense
              solo
              label="用户名"
              v-model="username"
              :rules="[rules.required, rules.userMax, rules.userText]"
            ></v-text-field>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-title class="primary darken-1 white--text py-1 mb-4">
            <h5 id="email">邮箱</h5>
          </v-card-title>
          <v-card-text>
            <span>邮箱是您的身份凭证之一，请不要在公共邮箱上注册MAKjustID，这会导致您可能被他人盗用账号。</span>
            <v-text-field
              dense
              solo
              label="邮箱"
              v-model="email"
              :rules="[rules.required, rules.emailIs]"
            ></v-text-field>
          </v-card-text>
          <v-divider></v-divider>
          <v-alert
            v-if="updateError"
            class="mx-4 mt-4"
            transition="slide-y-transition"
            type="error"
            dense
          >{{updateError}}</v-alert>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn depressed :loading="uploading" color="primary" @click="updates()">更新资料</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
      <h3 class="mt-4">账户</h3>
      <v-card>
        <v-card-title class="cyan darken-3 white--text py-1 mb-4">
          <h5 id="oauth">第三方OAuth</h5>
        </v-card-title>
        <v-card-text>
          <span>第三方OAuth即第三方登陆服务，可以通过我们支持的第三方服务来快速登陆账号。</span>
          <v-divider></v-divider>
          <v-list class="py-0">
            <v-list-item v-for="item in oauthServices" :key="item.type">
              <v-list-item-icon>
                <v-icon>{{item.icon}}</v-icon>
              </v-list-item-icon>
              <v-list-item-content>{{item.name}}</v-list-item-content>
              <v-list-item-action>
                <v-btn v-if="$store.state.USER.authData[item.type]" color="light-blue darken-3" :to="`/account/bind.php?service=${item.type}`" disabled outlined tile>
                  <v-icon>done</v-icon>已绑定
                </v-btn>
                <v-btn v-else color="cyan darken-3" :to="`/account/bind.php?service=${item.type}`"  outlined tile>
                  <v-icon>add</v-icon>未绑定
                </v-btn>
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </v-card-text>
        <v-card-title class="cyan darken-3 white--text py-1 mb-4">
          <h5 id="pay">绿宝石</h5>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="4">
              <v-card flat color="grey lighten-2">
                <v-card-text class="py-2">账单</v-card-text>
                <v-card-title class="py-0">————</v-card-title>
                <v-card-text class="py-2">
                  <a class="my-0 text-end">年度账单</a>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="4">
              <v-card flat color="grey lighten-2">
                <v-card-text class="py-2">我的绿宝石</v-card-text>
                <v-card-title class="py-0">{{$store.state.USER.emerald}}</v-card-title>
                <v-card-text class="py-2">
                  <p class="my-0 text-end">颗</p>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn depressed color="cyan darken-3" dark>
            充值
            <v-icon size="16">open_in_new</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
      <h3 class="mt-4">安全</h3>
      <v-alert v-if="!$store.state.USER.emailVerified" type="error">您必须完成邮箱验证后才能操作。</v-alert>
      <v-card :disabled="!$store.state.USER.emailVerified">
        <v-card-title class="teal darken-1 white--text py-1 mb-4">
          <h5 id="2fa">双因子认证</h5>
        </v-card-title>
        <v-card-text>
          <p class="text-center my-0">
            <v-icon>lock</v-icon>
            <br />
            <span style="font-weight:900;">双因子认证(Two-factor authentication)</span>
            <br />双因子认证是一种在密码之上的账户保护方案。
          </p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn depressed color="teal darken-1" disabled>开启二步验证</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
        <v-divider></v-divider>
        <v-card-title class="teal darken-1 white--text py-1 mb-4">
          <h5 id="repassword">更改密码</h5>
        </v-card-title>
        <v-card-text>
          <v-form ref="findpwd" style="color:rgba(0, 0, 0, 0.6);">
            <v-text-field
              dense
              type="password"
              solo
              class="pt-0"
              label="原密码"
              v-model="oldPassword"
              :rules="[rules.required, rules.pwdMin]"
            ></v-text-field>
            <v-text-field
              dense
              type="password"
              solo
              class="pt-0"
              label="新密码"
              v-model="newPassword"
              :rules="[rules.required, rules.pwdMin]"
            ></v-text-field>
            <v-text-field
              dense
              type="password"
              solo
              class="pt-0"
              label="确认密码"
              :rules="[rules.required, rules.isp]"
            ></v-text-field>
          </v-form>
        </v-card-text>
        <v-alert
          v-if="findPwdMsg[0] > -1"
          class="mx-4"
          transition="slide-y-transition"
          :type="findPwdMsg[1]"
          dense
        >{{findPwdMsg[2]}}</v-alert>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn depressed :loading="finding" color="teal darken-1" dark @click="findPwd()">提交密码</v-btn>
        </v-card-actions>
      </v-card>
      <h3 class="mt-4">其他</h3>
      <v-card disabled>
        <v-card-title>
          <span class="red--text">重置账号</span>
        </v-card-title>
        <v-card-text>
          您确定要重置在 MAKjustID 所注册的账号吗？
          <br />重置账号将重置除 UUID 外的所有信息。
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn depressed color="red" dark>重置</v-btn>
        </v-card-actions>
        <v-divider></v-divider>
        <v-card-title>
          <span class="red--text">注销账号</span>
        </v-card-title>
        <v-card-text>
          您确定要注销在 MAKjustID 所注册的账号吗？
          <br />我们将会删除您在我们所保存、上传的所有数据。
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn depressed color="red" dark>注销</v-btn>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import mjp from "../../plugins/makjust";
export default {
  data() {
    return {
      username: this.$store.state.USER.username,
      email: this.$store.state.USER.email,
      oldPassword: "",
      newPassword: "",
      uploading: false,
      finding: false,
      updateError: "",
      findPwdMsg: [-1, "error", ""],
      rules: {
        required: value => !!value || "此项不能为空",
        userMax: v => v.length <= 10 || "用户名不能超过10个字符",
        userText: v =>
          /^[a-zA-Z0-9]+$/.test(v) || "用户名只能是英文与数字的结合",
        emailIs: v =>
          /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/.test(
            v
          ) || "这不是一个正确的电子邮箱",
        pwdMin: v => v.length >= 6 || "这最少应该是一个6位的密码",
        isp: v => v === this.newPassword || "密码不一致"
      },
      oauthServices:[
        {
          name: '腾讯QQ',
          icon: 'iconfont icon-qq',
          type: 'qq'
        },
        {
          name: 'GitHub',
          icon: 'iconfont icon-github',
          type: 'github'
        },
      ]
    };
  },
  updated() {},
  methods: {
    setAvatar() {
      //更换头像
    },
    updates() {
      //更新用户资料
      this.uploading = true;
      if (this.$refs.updates.validate()) {
        mjp
          .updates(
            this.$store.state.USER.objectId,
            this.$store.state.USER.sessionToken,
            {
              username: this.username,
              userfullid: this.username.toUpperCase(),
              email: this.email
            }
          )
          .then(r => {
            if (r[0]) {
              this.uploading = false;
              this.$router.go(0);
            } else {
              this.updateError = "更新资料时发生了错误：" + r[1];
              this.uploading = false;
            }
          });
      } else {
        this.updateError = "请正确填写！";
        this.uploading = false;
      }
    },
    findPwd() {
      if (this.$refs.findpwd.validate()) {
        mjp
          .findPassword(
            this.$store.state.USER.objectId,
            this.$store.state.USER.sessionToken,
            this.oldPassword,
            this.newPassword
          )
          .then(r => {
            if (r) {
              this.findPwdMsg = [1, "success", "密码已更新。"];
              this.finding = false;
            } else {
              this.findPwdMsg = [
                1,
                "error",
                "更新密码失败，请检查原密码是否正确。"
              ];
              this.finding = false;
            }
          });
      } else {
        this.finding = false;
      }
    },
    toHome() {
      this.$router.push("/");
      this.$store.state.NAV.drawer = false;
    }
  }
};
</script>

<style>
.account-avatar {
  position: absolute;
  width: 66px;
  transform: translate(-50%, -22px);
  top: 0;
  left: 50%;
  right: 50%;
}
.account-infobox {
  display: flex;
  align-items: flex-end;
  font-size: 1.1rem;
}
.account-infobox h5 {
  display: inline;
}
.account-infobox span {
  width: 100%;
}
</style>
